import { gql } from "@apollo/client";

// See more example queries on https://thegraph.com/explorer/subgraph/paulrberg/create-eth-app
export const GET_USER_EPOCH_WALLETS = gql`
  query getUserEpochWallet($id: String!) {
    userEntity(id: $id) {
      activeWallet {
        walletAddress
      }
      wallets {
        walletAddress
      }
    }
  }
`;

export const GET_JOBS_INFO = gql`
query getJobInfoEventEntities($id: String!) {
    jobInfoEventEntities(id: $id) {
      id
      executionInterval
      strictExecution
      jobInfoData
      initiatorAddress
      executionContract
      functionSignature
      tokensInvolved
      data
    }
  }
`;

export const GET_JOBS_INFO_LIST = gql`
  {
    jobInfoEventEntities {
      id
      executionInterval
      strictExecution
      jobInfoData
      initiatorAddress
      executionContract
      functionSignature
      tokensInvolved
      data
    }
  }
`;
